import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormControl } from '@angular/forms';
import { MatChipInputEvent } from '@angular/material/chips';

@Component({
    selector: 'app-multiple-inputs',
    templateUrl: './multiple-inputs.component.html',
    styleUrls: ['./multiple-inputs.component.scss'],
    standalone: false
})
export class MultipleInputsComponent implements OnInit {
  @Input() targetFormArray: UntypedFormArray;
  @Input() label: string;

  readonly separatorKeyCodes: number[] = [ENTER, COMMA];

  constructor() {}

  ngOnInit(): void {}

  trackByFn(index: any) {
    return index;
  }

  removeControl(index: number) {
    this.targetFormArray.removeAt(index);
  }

  addControl(evt: MatChipInputEvent) {
    let value = evt.value;

    this.targetFormArray.push(new UntypedFormControl(value));

    if (evt.input) evt.input.value = '';
  }

  drop(evt: CdkDragDrop<UntypedFormControl>) {
    moveItemInArray(
      this.targetFormArray.controls,
      evt.previousIndex,
      evt.currentIndex
    );
  }
}
